import React, { useEffect } from 'react';
import {
  ListingDetailsType,
  CustomFieldsType,
  addListingDetailsType,
} from '~addListing/types';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Input } from '@aqarmap/aqarmap-ui';
import { handleAttributeChange } from '~addListing/utils/handleAttributeChange';

const LandArea = ({
  listing,
  customFieldsData,
  errorAttributeIds,
  setErrorAttributeIds,
}: {
  listing: ListingDetailsType;
  customFieldsData: { attributes: CustomFieldsType[] };
  errorAttributeIds: number[];
  setErrorAttributeIds: React.Dispatch<React.SetStateAction<number[]>>;
}) => {
  const landAreaKey = 'land-area';
  const { t } = useTranslation('app');
  const listingPropertyTypeId = listing?.property_type.id;
  const landAreaData = customFieldsData.attributes?.find(
    (field: CustomFieldsType) => field.name === landAreaKey,
  );
  const landAreaDataId = Number(landAreaData?.id);
  const isError = errorAttributeIds.includes(landAreaDataId);

  const renderLandArea = Object.values(
    landAreaData?.virtualPropertyTypesIds || {},
  ).includes(listingPropertyTypeId);

  const { setValue, getValues } = useFormContext<addListingDetailsType>();
  const defaultLandAreaValue =
    listing?.attributes.find((att) => att.custom_field.id === landAreaDataId)
      ?.value || 0;

  if (!renderLandArea) return null;

  useEffect(() => {
    setValue(
      'attributes',
      handleAttributeChange(
        getValues('attributes'),
        landAreaDataId,
        defaultLandAreaValue,
      ),
    );
  }, [isError]);

  return (
    <Input
      label={{
        text: t('landArea'),
        className: 'text-title_4 text-black',
      }}
      field={{
        placeholder: t('landAreaPlaceholder'),
        className:
          'text-gray__dark_2 text-gray__dark_2 placeholder:text-gray__dark_1 [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none [&::-moz-appearance:textfield]',
        type: 'number',
        defaultValue: defaultLandAreaValue !== 0 ? defaultLandAreaValue : '',
        onChange: (e) => {
          const value = Number(e.target.value);
          if (value >= 0)
            handleAttributeChange(
              getValues('attributes'),
              landAreaDataId,
              value,
            );
          else
            handleAttributeChange(getValues('attributes'), landAreaDataId, 0);
        },
        min: 0,
        onFocus: () =>
          setErrorAttributeIds((prev) =>
            prev.filter((id) => id !== landAreaDataId),
          ),
        onWheel: (e) => (e.target as HTMLInputElement).blur(),
      }}
      error={isError ? t('landAreaError') : ''}
    />
  );
};

export default LandArea;
